<div class="container">
  <div class="image-container">
    <img src="../../../assets/images/cotecna-eye-icon.png" />
    <mat-icon>lock</mat-icon>
  </div>
  <div class="content">
    <div class="primary-text">
      <p>Access Denied</p>
    </div>
    <div class="secondary-text">
      <span>You are not authorized to access this page.</span>
    </div>
  </div>
</div>
